import { useState } from 'react';

import { getMembers } from '@src/api/member';
import { GetMembersQuery } from '@src/api/member/getMembers';
import { useInfiniteQuery } from 'react-query';

const useGetMembers = (props: Partial<GetMembersQuery>) => {
  const [total, setTotal] = useState<number>(0);

  const response = useInfiniteQuery(
    ['MEMBERS_LIST', props?.page, props.q, props],
    async ({ pageParam: page = 1 }) => {
      const query: GetMembersQuery = {
        page,
        limit: 10,
        property: 'name',
        ...props,
      };

      const response = await getMembers({ query });

      if (response) setTotal(response.count);

      return response;
    },
    {
      getNextPageParam: (_, pageParam) => {
        const result = pageParam.length + 1;
        return result;
      },
      getPreviousPageParam: (_, pageParam) => {
        const result = pageParam.length - 1;
        return result || 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  const data =
    response.data?.pages?.filter(v => v)?.flatMap(data => (data ? data.rows.map(v => v) : [])) ||
    [];

  return { ...response, data, total };
};

export default useGetMembers;
